import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LoadingIconButton from './LoadingIconButton';
import ClientProvider from './client';
export default createDemo(import.meta.url, LoadingIconButton, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/loading-icon/LoadingIconButton.tsx",
    "fileName": "LoadingIconButton.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Tooltip from '@mui/material/Tooltip';\nimport IconButton from '@mui/material/IconButton';\nimport ShoppingCartIcon from '@mui/icons-material/ShoppingCart';\n\nexport default function LoadingIconButton() {\n  const [loading, setLoading] = React.useState(false);\n  React.useEffect(() => {\n    const timeout = setTimeout(() => {\n      setLoading(false);\n    }, 2000);\n    return () => clearTimeout(timeout);\n  });\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Tooltip title=\"Click to see loading\">\n      <IconButton onClick={() => setLoading(true)} loading={loading}>\n        <ShoppingCartIcon />\n      </IconButton>\n    </Tooltip>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 21,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Tooltip from '@mui/material/Tooltip';\nimport IconButton from '@mui/material/IconButton';\nimport ShoppingCartIcon from '@mui/icons-material/ShoppingCart';\n\nexport default function LoadingIconButton() {\n  const [loading, setLoading] = React.useState(false);\n  React.useEffect(() => {\n    const timeout = setTimeout(() => {\n      setLoading(false);\n    }, 2000);\n    return () => clearTimeout(timeout);\n  });\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Tooltip title=\"Click to see loading\">\n      <IconButton onClick={() => setLoading(true)} loading={loading}>\n        <ShoppingCartIcon />\n      </IconButton>\n    </Tooltip>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tooltip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Click to see loading",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ",
              [
                "span",
                "pl-en",
                "setLoading"
              ],
              "(",
              [
                "span",
                "pl-c1 di-bool",
                "true"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "loading"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ShoppingCartIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Tooltip"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 21,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Tooltip",
      "@mui/material/IconButton",
      "@mui/icons-material/ShoppingCart"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
